// extracted by mini-css-extract-plugin
export var root = "_0u0I";